module.exports = __webpack_public_path__ + "static/incard1-ce42c5d89e55bf60cbc2542ad16ef626.png";